import { LocalStorage } from "../LocalStorage";

export default function authHeader(token: string) {
  return { 'x-auth-token': token };

  /*

  const userStr = LocalStorage.getUser()
  let user = null;
  if (userStr)
    user = JSON.parse(userStr);
 
  if (user && user.accessToken) {
    // return { Authorization: 'Bearer ' + user.accessToken }; // for Spring Boot back-end
    return { 'x-auth-token': user.accessToken };       // for Node.js Express back-end
  } else {
    return { 'x-auth-token': LocalStorage.getJwtToken() };
  }
  */
}